// extracted by mini-css-extract-plugin
export default {"header":"JkaEjidZwp54ZSak43H4","cancelHolder":"akGBNgjxWaJcCOipX0nH"};